<script setup lang="ts">
//
</script>

<template>
  <div>
    <svg
      class="w-16 mx-auto z-0"
      viewBox="0 -20 64 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 1">
        <path
          id="Line"
          class="logo-line"
          style="animation-delay: 0s"
          d="M59 7.04C58.1163 7.04 57.4 6.32368 57.4 5.44V1.6C57.4 0.7164 58.1163 0 59 0C59.8837 0 60.6 0.7164 60.6 1.6V5.44C60.6 6.32368 59.8837 7.04 59 7.04Z"
          fill="url(#paint0_linear_1_35)"
        />
        <path
          id="Line_2"
          class="logo-line"
          style="animation-delay: 0.1s"
          d="M51.96 10.88C51.0763 10.88 50.36 10.1637 50.36 9.28V1.6C50.36 0.7164 51.0763 0 51.96 0C52.8437 0 53.56 0.7164 53.56 1.6V9.28C53.56 10.1637 52.8437 10.88 51.96 10.88Z"
          fill="url(#paint1_linear_1_35)"
        />
        <path
          id="Line_3"
          class="logo-line"
          style="animation-delay: 0.2s"
          d="M43.32 12.48C43.32 13.3637 44.0363 14.08 44.92 14.08C45.8037 14.08 46.52 13.3637 46.52 12.48V6.72C46.52 5.8364 45.8037 5.12 44.92 5.12C44.0363 5.12 43.32 5.8364 43.32 6.72V12.48Z"
          fill="url(#paint2_linear_1_35)"
        />
        <path
          id="Line_4"
          class="logo-line"
          style="animation-delay: 0.3s"
          d="M37.88 19.2C36.9963 19.2 36.28 18.4837 36.28 17.6V11.84C36.28 10.9564 36.9963 10.24 37.88 10.24C38.7637 10.24 39.48 10.9564 39.48 11.84V17.6C39.48 18.4837 38.7637 19.2 37.88 19.2Z"
          fill="url(#paint3_linear_1_35)"
        />
        <path
          id="Line_5"
          class="logo-line"
          style="animation-delay: 0.4s"
          d="M27 37.12C26.1163 37.12 25.4 36.4037 25.4 35.52V31.04C25.4 30.1564 26.1163 29.44 27 29.44C27.8837 29.44 28.6 30.1564 28.6 31.04V35.52C28.6 36.4037 27.8837 37.12 27 37.12Z"
          fill="url(#paint4_linear_1_35)"
        />
        <path
          id="Line_6"
          class="logo-line"
          style="animation-delay: 0.5s"
          d="M19.96 42.88C19.0763 42.88 18.36 42.1637 18.36 41.28V33.6C18.36 32.7164 19.0763 32 19.96 32C20.8437 32 21.56 32.7164 21.56 33.6V41.28C21.56 42.1637 20.8437 42.88 19.96 42.88Z"
          fill="url(#paint5_linear_1_35)"
        />
        <path
          id="Line_7"
          class="logo-line"
          style="animation-delay: 0.6s"
          d="M11.32 45.76C11.32 46.6437 12.0363 47.36 12.92 47.36C13.8037 47.36 14.52 46.6437 14.52 45.76V40C14.52 39.1164 13.8037 38.4 12.92 38.4C12.0363 38.4 11.32 39.1164 11.32 40V45.76Z"
          fill="url(#paint6_linear_1_35)"
        />
        <path
          id="Line_8"
          class="logo-line"
          style="animation-delay: 0.7s"
          d="M3 44.48C3 45.3637 3.71634 46.08 4.6 46.08C5.48366 46.08 6.2 45.3637 6.2 44.48V40C6.2 39.1164 5.48366 38.4 4.6 38.4C3.71634 38.4 3 39.1164 3 40V44.48Z"
          fill="url(#paint7_linear_1_35)"
        />
        <path
          id="Vector"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.00697595 4.36408C0.122617 6.1276 1.64598 7.46352 3.4095 7.34784C8.93728 6.98536 22.4322 9.79976 29.4226 24.7129L29.4808 24.8369L29.5493 24.9554C32.6774 30.3704 36.2023 35.2666 41.1027 38.9223C46.0593 42.62 52.1923 44.8803 60.2637 45.4275C62.027 45.547 63.5533 44.2146 63.6728 42.4513C63.7923 40.688 62.4598 39.1617 60.6966 39.0422C53.6639 38.5654 48.757 36.6478 44.9295 33.7926C41.0752 30.9171 38.088 26.9242 35.1577 21.8692C26.7702 4.12416 10.4585 0.471918 2.99073 0.961598C1.22721 1.0772 -0.108666 2.60056 0.00697595 4.36408Z"
          fill="#5BB1E9"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1_35"
          x1="-3.07837"
          y1="-8.63998"
          x2="57.4274"
          y2="16.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.015625" stop-color="#6EE5B3" />
          <stop offset="0.430034" stop-color="#68D8E2" />
          <stop offset="1" stop-color="#4475F6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_35"
          x1="-3.07837"
          y1="-8.63998"
          x2="57.4275"
          y2="16.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.015625" stop-color="#6EE5B3" />
          <stop offset="0.430034" stop-color="#68D8E2" />
          <stop offset="1" stop-color="#4475F6" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_35"
          x1="-3.07837"
          y1="-8.63998"
          x2="57.4275"
          y2="16.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.015625" stop-color="#6EE5B3" />
          <stop offset="0.430034" stop-color="#68D8E2" />
          <stop offset="1" stop-color="#4475F6" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_35"
          x1="-3.07837"
          y1="-8.63998"
          x2="57.4275"
          y2="16.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.015625" stop-color="#6EE5B3" />
          <stop offset="0.430034" stop-color="#68D8E2" />
          <stop offset="1" stop-color="#4475F6" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1_35"
          x1="-3.07837"
          y1="-8.63998"
          x2="57.4275"
          y2="16.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.015625" stop-color="#6EE5B3" />
          <stop offset="0.430034" stop-color="#68D8E2" />
          <stop offset="1" stop-color="#4475F6" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1_35"
          x1="-3.07837"
          y1="-8.63998"
          x2="57.4275"
          y2="16.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.015625" stop-color="#6EE5B3" />
          <stop offset="0.430034" stop-color="#68D8E2" />
          <stop offset="1" stop-color="#4475F6" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1_35"
          x1="-3.07837"
          y1="-8.63999"
          x2="57.4275"
          y2="16.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.015625" stop-color="#6EE5B3" />
          <stop offset="0.430034" stop-color="#68D8E2" />
          <stop offset="1" stop-color="#4475F6" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1_35"
          x1="-3.07837"
          y1="-8.63998"
          x2="57.4275"
          y2="16.3289"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.015625" stop-color="#6EE5B3" />
          <stop offset="0.430034" stop-color="#68D8E2" />
          <stop offset="1" stop-color="#4475F6" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<style>
.logo-line {
  transform-origin: center;
  animation: lines-animation 1.3s infinite ease;
}

@keyframes lines-animation {
  0% {
    transform: translateY(0px);
  }

  25% {
    transform: translateY(-5px);
  }

  50% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>
